export default "__VITE_ASSET__BWmYcUCV__"